import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ScrollToTop from './utils/ScrollToTop';
import PageNotFound from './pages/PageNotFound';
import Layout from './layout/Layout';
import Signin from './pages/Signin';
import Dashboard from './pages/dashboard/Dashboard';
import Farmers from './pages/Farmers';
import Orders from './pages/sales/Orders';
import Shipments from './pages/sales/Shipments';
import Payments from './pages/sales/Payments';
import Products from './pages/store/Products';
import ProductCreatePage from './pages/store/ProductCreatePage';
import StoreDetails from './pages/store/StoreDetails';
import AccountSettings from './pages/AccountSettings';
import Whatsapp from './pages/Whatsapp';
import WhatsappMonitor from './pages/WhatsappMonitor';
import ShopVisitorView from './pages/enquiries/ShopVisitorView';
import ProductVisitorView from './pages/enquiries/ProductVisitorView';
import AddFarmer from './pages/AddFarmer';
import Notifications from './pages/Notifications';
import AddNotification from './pages/AddNotification';
import AddShipment from './pages/sales/AddShipment';
import AddUserPointsForm from './pages/AddUserPointsForm';
import Manufacturers from './pages/bazaar/Manufacturer';
import ManufacturerForm from './pages/bazaar/ManufacturerForm';
import Shop from './pages/bazaar/Shops';
import ShopForm from './pages/bazaar/ShopForm';
import Domains from './pages/bazaar/Domains';
import DomainForm from './pages/bazaar/DomainForm';
import CategoryForm from './pages/bazaar/CategoryForm';
import SubCategoryForm from './pages/bazaar/SubCategoryForm';
import ShopProductDimensions from './pages/bazaar/ShopProductDimensions';
import Enquiries from './pages/enquiries/Enquiries';
import { getUserRole, isB2bSalesperson } from './helpers/local_storage_helpers';
import StaffDashboard from './pages/StaffDashboard';
import PrimaryProducts from './pages/store/PrimaryProducts';
import Community from './pages/marketing/Community';
import CommunityForm from './pages/marketing/CommunityForm';
import Forum from './pages/marketing/Forum';
import SatelliteEnquiry from './pages/satellite/SatelliteEnquiry';
import SatelliteApprovedFarms from './pages/satellite/SatelliteApprovedFarms';
import Dynacrop from './pages/satellite/Dynacrop';
import DynacropDetail from './pages/satellite/DynacropDetail';
import Weather from './pages/weather/Weather';
import Leads from './pages/Leads';
import ProductDetailedPage from './pages/store/ProductDetailedPage';
import Banners from './pages/marketing/Banners';
import BannersForm from './pages/marketing/BannersForm';
import MobilePopups from './pages/marketing/MobilePopups';
import MobilePopupForm from './pages/marketing/MobilePopupForm';
import BulkEnquiries from './pages/enquiries/BulkEnquiries';
import NotificationCampaign from './pages/marketing/NotificationCampaign';
import NotificationCampaignForm from './pages/marketing/NotificationCampaignForm';
import NotificationCampaignTemplateView from './pages/marketing/NotificationCampaignTemplateView';
import FPOs from './pages/enquiries/FPOs';
import FpoCbboForm from './pages/enquiries/FpoCbboForm';
import FpoFpoForm from './pages/enquiries/FpoFpoForm';
import Scripts from './pages/Scripts';
import ManageOrdersView from './pages/sales/ManageOrdersView';
import ManageOrderForm from './pages/sales/ManageOrderForm';
import TelecallingView from './pages/TelecallingView';
import TelecallingActiveView from './pages/TelecallingActiveView';
import Devices from './pages/Devices';
import LeadStats from './pages/LeadStats';
import UserOrderHistory from './pages/sales/UserOrderHistory';
import InventoryDashboard from './pages/inventory/InventoryDashboard';
import RawItemsInventory from './pages/inventory/RawItemsInventory';
import KitAssembly from './pages/inventory/KitAssembly';
import DamageReplacements from './pages/inventory/DamageReplacements';
import SupportTickets from './pages/SupportTickets';
import RawItemsInventoryForm from './pages/inventory/RawItemsInventoryForm';
import KitAssemblyForm from './pages/inventory/KitAssemblyForm';
import ReportDamageForm from './pages/inventory/ReportDamageForm';
import RequestReplacementForm from './pages/inventory/RequestReplacementForm';
import StatusReportForm from './pages/inventory/StatusReportForm';
import ProductInventory from './pages/inventory/ProductInventory';
import ProductInventoryForm from './pages/inventory/ProductInventoryForm';
import Chatbot from './pages/Chatbot';
import AIAnalytics from './pages/AIAnalytics';
import BlogDashboard from './pages/blog/BlogDashboard';
import BlogCategories from './pages/blog/BlogCategories';
import BlogTags from './pages/blog/BlogTags';
import BlogPosts from './pages/blog/BlogPosts';
import BlogCategoryFormPage from './pages/blog/BlogCategoryFormPage';
import BlogTagFormPage from './pages/blog/BlogTagFormPage';
import BlogPostFormPage from './pages/blog/BlogPostFormPage';
import Sheets from './pages/Sheets';
import Drive from './pages/Drive';
import EmployeeSheets from './pages/EmployeeSheets';
import SheetView from './pages/SheetView';
import DownloadSheets from './pages/DownloadSheets';
import AIUserChats from './pages/AIUserChats';
import UserChatHistory from './pages/UserChatHistory';
import B2BLeads from './pages/leads-management/b2b/B2BLeads';
import B2BLeadUpload from './pages/leads-management/b2b/B2BLeadUpload';
import B2BFolders from './pages/leads-management/b2b/B2BFolders';
import B2BSalesPersonView from './pages/leads-management/b2b/B2BSalesPersonView';
import B2BDealersView from './pages/leads-management/b2b/B2BDealersView';
import PaidB2BDealers from './pages/leads-management/b2b/PaidB2BDealers';
import B2CSalesPersonView from './pages/leads-management/b2c/B2CSalesPersonView';
// import B2CStatsView from './pages/leads-management/b2c/B2CStatsView';
// import B2CMasterSheetView from './pages/leads-management/b2c/B2CMasterSheetView';
import B2CInterestedLeadsView from './pages/leads-management/b2c/B2CInterestedLeadsView';
import B2CSalespersonDailyCallStats from './pages/leads-management/b2c/B2CSalespersonDailyCallStats';
import LabelInvoiceGenerator from './pages/sales/LabelInvoiceGenerator';
import ProformaInvoiceEdit from './pages/sales/ProformaInvoiceEdit';
import EcomEnquiries from './pages/sales/EcomEnquiries';
import SalesDashboard from './pages/sales/SalesDashboard';
import ProductSales from './pages/sales/ProductSales';
import ProductSalesDetail from './pages/sales/ProductSalesDetail';
import ProductSalesCombined from './pages/sales/ProductSalesCombined';
import B2BLedgerPage from './pages/sales/B2BLedgerPage';
import B2CLedgerPage from './pages/sales/B2CLedgerPage';
import ShippingTrackingDashboard from './pages/sales/ShippingTrackingDashboard';
import B2CSalesAdminDashboard from './pages/dashboard/B2CSalesAdminDashboard';
import HrAttendanceDashboard from './pages/dashboard/HrAttendanceDashboard';

import IotDevices from './pages/IoTDevices';
import IotSubscriptionManager from './pages/IotDeviceSubscription';
import FlowBuilder from './pages/flow_builder/FlowBuilder';

function App() {
  const role = getUserRole();
  const isAdmin = role === "admin";
  const isStaff = role === "staff";
  const isHrAdmin = role === "hr-admin";
  const isB2bSalespersonUser = isB2bSalesperson();

  return (
    <Router>
      <ScrollToTop />
      <div className='w-full'>
        <Routes>
          <Route
            exact
            path="/"
            element={
              <Layout noSidebar>
                <Signin />
              </Layout>
            }
          />
          {isAdmin ?
            <Route
              exact
              path="/dashboard"
              element={
                <Layout>
                  <Dashboard />
                </Layout>
              }
            /> : isHrAdmin ?
            <Route
              exact
              path="/dashboard"
              element={
                <Layout>
                  <HrAttendanceDashboard />
                </Layout>
              }
          /> :
            <Route
              exact
              path="/dashboard"
              element={
                <Layout>
                  <StaffDashboard />
                </Layout>
              }
            />}
          {getUserRole() === "admin" ? <Route exact path="/whatsapp/monitor" element={<Layout><WhatsappMonitor /></Layout>} /> : <></>}
          {getUserRole() === "admin" ? <Route
            exact
            path="/whatsapp"
            element={
              <Layout>
                <Whatsapp />
              </Layout>
            }
          /> : <></>}
          <Route
            exact
            path="/weather"
            element={
              <Layout>
                <Weather />
              </Layout>
            }
          />
          {/* Sheets/Drive */}
          {getUserRole() === "admin" ? (
            <Route
              exact
              path="/drive"
              element={
                <Layout>
                  <Drive />
                </Layout>
              }
            />
          ) : (
            <Route
              exact
              path="/sheets"
              element={
                <Layout>
                  <Sheets />
                </Layout>
              }
            />
          )}
          {getUserRole() === "admin" ? (
            <Route
              exact
              path="/drive/:employeeId"
              element={
                <Layout>
                  <EmployeeSheets />
                </Layout>
              }
            />
          ) : <></>}
          {/* Sheet view shared */}
          <Route
            exact
            path="/sheets/:id"
            element={
              <Layout>
                <SheetView />
              </Layout>
            }
          />
          {/* Download Sheets */}
          {getUserRole() === "admin" || getUserRole() === "staff" ? (
            <Route
              exact
              path="/download-sheets"
              element={
                <Layout>
                  <DownloadSheets />
                </Layout>
              }
            />
          ) : <></>}
          {getUserRole() === "admin" || getUserRole() === "staff" ? <Route
            exact
            path="/satellite/list"
            element={
              <Layout>
                <SatelliteEnquiry />
              </Layout>
            }
          /> : <></>}
          {getUserRole() === "admin" || getUserRole() === "staff" ? <Route
            exact
            path="/satellite/approved-farms"
            element={
              <Layout>
                <SatelliteApprovedFarms />
              </Layout>
            }
          /> : <></>}
          {getUserRole() === "admin" || getUserRole() === "staff" ? <Route
            exact
            path="/satellite/dynacrop"
            element={
              <Layout>
                <Dynacrop />
              </Layout>
            }
          /> : <></>}
          {getUserRole() === "admin" || getUserRole() === "staff" ? <Route
            exact
            path="/satellite/dynacrop/:id"
            element={
              <Layout>
                <DynacropDetail />
              </Layout>
            }
          /> : <></>}
          {getUserRole() === "admin" || getUserRole() === "staff" ? <Route
            exact
            path="/chatbot"
            element={
              <Layout>
                <Chatbot />
              </Layout>
            }
          /> : <></>}
          {getUserRole() === "admin" || getUserRole() === "staff" ? <Route
            exact
            path="/ai-analytics"
            element={
              <Layout>
                <AIAnalytics />
              </Layout>
            }
          /> : <></>}
          {getUserRole() === "admin" || getUserRole() === "staff" ? <Route
            exact
            path="/ai-user-chats"
            element={
              <Layout>
                <AIUserChats />
              </Layout>
            }
          /> : <></>}
          {getUserRole() === "admin" || getUserRole() === "staff" ? <Route
            exact
            path="/ai-user-chats/:userId"
            element={
              <Layout>
                <UserChatHistory />
              </Layout>
            }
          /> : <></>}
          {isAdmin || isStaff || isHrAdmin ? <Route
            exact
            path="/blog/dashboard"
            element={
              <Layout>
                <BlogDashboard />
              </Layout>
            }
          /> : <></>}
          {isAdmin || isStaff || isHrAdmin ? <Route
            exact
            path="/blog/categories"
            element={
              <Layout>
                <BlogCategories />
              </Layout>
            }
          /> : <></>}
          {isAdmin || isStaff || isHrAdmin ? <Route
            exact
            path="/blog/tags"
            element={
              <Layout>
                <BlogTags />
              </Layout>
            }
          /> : <></>}
          {isAdmin || isStaff || isHrAdmin ? <Route
            exact
            path="/blog/posts"
            element={
              <Layout>
                <BlogPosts />
              </Layout>
            }
          /> : <></>}
          {isAdmin || isStaff || isHrAdmin ? <Route
            exact
            path="/blog/categories/create"
            element={
              <Layout>
                <BlogCategoryFormPage />
              </Layout>
            }
          /> : <></>}
          {isAdmin || isStaff || isHrAdmin ? <Route
            exact
            path="/blog/categories/edit/:id"
            element={
              <Layout>
                <BlogCategoryFormPage />
              </Layout>
            }
          /> : <></>}
          {isAdmin || isStaff || isHrAdmin ? <Route
            exact
            path="/blog/tags/create"
            element={
              <Layout>
                <BlogTagFormPage />
              </Layout>
            }
          /> : <></>}
          {isAdmin || isStaff || isHrAdmin ? <Route
            exact
            path="/blog/tags/edit/:id"
            element={
              <Layout>
                <BlogTagFormPage />
              </Layout>
            }
          /> : <></>}
          {isAdmin || isStaff || isHrAdmin ? <Route
            exact
            path="/blog/posts/create"
            element={
              <Layout>
                <BlogPostFormPage />
              </Layout>
            }
          /> : <></>}
          {isAdmin || isStaff || isHrAdmin ? <Route
            exact
            path="/blog/posts/edit/:id"
            element={
              <Layout>
                <BlogPostFormPage />
              </Layout>
            }
          /> : <></>}
          {getUserRole() === "admin" ? <Route
            exact
            path="/notification"
            element={
              <Layout>
                <Notifications />
              </Layout>
            }
          /> : <></>}
          {getUserRole() === "admin" ? <Route
            exact
            path="/devices"
            element={
              <Layout>
                <Devices />
              </Layout>
            }
          /> : <></>}
          {getUserRole() === "admin" ? <Route
            exact
            path="/iot-devices"
            element={
              <Layout>
                <IotDevices />
              </Layout>
            }
          /> : <></>}
          {getUserRole() === "admin" ? <Route
            exact
            path="/iot-subscription"
            element={
              <Layout>
                <IotSubscriptionManager />
              </Layout>
            }
          /> : <></>}
          {getUserRole() === "admin" ? <Route
            exact
            path="/notification/add"
            element={
              <Layout>
                <AddNotification />
              </Layout>
            }
          /> : <></>}
          {getUserRole() === "admin" ? <Route
            exact
            path="/leads"
            element={
              <Layout>
                <Leads />
              </Layout>
            }
          /> : <></>}
          {getUserRole() === "admin" ? <Route
            exact
            path="/lead-stats"
            element={
              <Layout>
                <LeadStats />
              </Layout>
            }
          /> : <></>}
          {getUserRole() === "admin" ? <Route
            exact
            path="/scripts"
            element={
              <Layout>
                <Scripts />
              </Layout>
            }
          /> : <></>}
          {isAdmin || isStaff || isHrAdmin ? <Route
            exact
            path="/support-tickets"
            element={
              <Layout>
                <SupportTickets />
              </Layout>
            }
          /> : <></>}
          {<Route
            exact
            path="/enquiries/fpos"
            element={
              <Layout>
                <FPOs />
              </Layout>
            }
          />}
          {<Route
            exact
            path="/enquiries/fpos/cbbo/:slug"
            element={
              <Layout>
                <FpoCbboForm />
              </Layout>
            }
          />}
          {<Route
            exact
            path="/enquiries/fpos/fpo/:slug"
            element={
              <Layout>
                <FpoFpoForm />
              </Layout>
            }
          />}
          {<Route
            exact
            path="/enquiries/visitors/shop"
            element={
              <Layout>
                <ShopVisitorView />
              </Layout>
            }
          />}
          {<Route
            exact
            path="/enquiries/visitors/products"
            element={
              <Layout>
                <ProductVisitorView />
              </Layout>
            }
          />}
          {<Route
            exact
            path="/enquiry"
            element={
              <Layout>
                <Enquiries />
              </Layout>
            }
          />}
          {<Route
            exact
            path="/enquiries/bulk-enquiries"
            element={
              <Layout>
                <BulkEnquiries />
              </Layout>
            }
          />}
          {/* <Route
            exact
            path="/enquiries/app"
            element={
              <Layout>
                <AppEnquiries />
              </Layout>
            }
          />
          <Route
            exact
            path="/enquiries/web"
            element={
              <Layout>
                <WebEnquiries />
              </Layout>
            }
          /> */}
          {getUserRole() === "admin" ? <Route
            exact
            path="/farmers"
            element={
              <Layout>
                <Farmers />
              </Layout>
            }
          /> : <></>}
          {getUserRole() === "admin" || getUserRole() === "staff" ? <Route
            exact
            path="/dukaan-users"
            element={
              <Layout>
                <Farmers userType='Dukaan' />
              </Layout>
            }
          /> : <></>}
          {getUserRole() === "admin" || getUserRole() === "staff" ? <Route
            exact
            path="/farmers/add"
            element={
              <Layout>
                <AddFarmer />
              </Layout>
            }
          /> : <></>}
          {getUserRole() === "admin" || getUserRole() === "staff" ? <Route
            exact
            path="/farmers/add-points"
            element={
              <Layout>
                <AddUserPointsForm />
              </Layout>
            }
          /> : <></>}
          {getUserRole() === "admin" || getUserRole() === "staff" || getUserRole() === "hr-admin" || isB2bSalespersonUser ? <Route
            exact
            path="/orders"
            element={
              <Layout>
                <Orders />
              </Layout>
            }
          /> : <></>}
          {getUserRole() === "admin" || getUserRole() === "staff" ? <Route
            exact
            path="/user-order-history"
            element={
              <Layout>
                <UserOrderHistory />
              </Layout>
            }
          /> : <></>}
          {getUserRole() === "staff" || getUserRole() === "admin" ? <Route
            exact
            path="/telecalling"
            element={
              <Layout>
                <TelecallingView />
              </Layout>
            }
          /> : <></>}
          {getUserRole() === "staff" || getUserRole() === "admin" ? <Route
            exact
            path="/active-view"
            element={
              <Layout>
                <TelecallingActiveView />
              </Layout>
            }
          /> : <></>}
          {/* B2B Leads Routes — My B2B Leads / My B2B Dealers: admin, staff, b2b-salesperson */}
          {isAdmin || isStaff || isB2bSalespersonUser ? (
            <>
              <Route exact path="/b2b-sales-person-view" element={<Layout><B2BSalesPersonView /></Layout>} />
              <Route exact path="/b2b-dealers-view" element={<Layout><B2BDealersView /></Layout>} />
            </>
          ) : <></>}

          {/* B2B Leads pool / upload / folders — admin & staff only (no b2b-salesperson access) */}
          {isAdmin || isStaff ? (
            <>
              <Route exact path="/leads-management/b2b/leads" element={<Layout><B2BLeads /></Layout>} />
              <Route exact path="/leads-management/b2b/upload" element={<Layout><B2BLeadUpload /></Layout>} />
              <Route exact path="/leads-management/b2b/folders" element={<Layout><B2BFolders /></Layout>} />
            </>
          ) : <></>}

          {/* Paid B2B Dealers — admin & b2b-salesperson only */}
          {isAdmin || isB2bSalespersonUser ? (
            <Route exact path="/paid-b2b-dealers-view" element={<Layout><PaidB2BDealers /></Layout>} />
          ) : <></>}

          {/* B2C Leads Routes */}
          {isAdmin || isStaff || isHrAdmin || isB2bSalespersonUser ? (
            <>
              <Route exact path="/b2c-sales-person-view" element={<Layout><B2CSalesPersonView /></Layout>} />
              {/* <Route exact path="/b2c-master-sheet-view" element={<Layout><B2CMasterSheetView /></Layout>} />
              <Route exact path="/b2c-stats-view" element={<Layout><B2CStatsView /></Layout>} /> */}
              <Route exact path="/b2c-interested-leads" element={<Layout><B2CInterestedLeadsView /></Layout>} />
            </>
          ) : <></>}
          {getUserRole() === "admin" ? (
            <Route exact path="/b2c-daily-call-stats" element={<Layout><B2CSalespersonDailyCallStats /></Layout>} />
          ) : <></>}
          {getUserRole() === "admin" ? (
            <Route exact path="/hr-admin-dashboard" element={<Layout><B2CSalesAdminDashboard /></Layout>} />
          ) : <></>}
          {getUserRole() === "admin" || getUserRole() === "hr-admin" ? (
            <Route exact path="/hr-attendance" element={<Layout><HrAttendanceDashboard /></Layout>} />
          ) : <></>}

          {<Route
            exact
            path="/manage-orders"
            element={
              <Layout>
                <ManageOrdersView />
              </Layout>
            }
          />}
          {<Route
            exact
            path="/manage-orders/add"
            element={
              <Layout>
                <ManageOrderForm />
              </Layout>
            }
          />}
          {getUserRole() === "admin" || getUserRole() === "staff" || isB2bSalespersonUser ? <Route
            exact
            path="/orders/add"
            element={
              <Layout>
                <ManageOrderForm />
              </Layout>
            }
          /> : <></>}
          {getUserRole() === "admin" ? <Route
            exact
            path="/orders/:slug"
            element={
              <Layout>
                <ManageOrderForm />
              </Layout>
            }
          /> : <></>}
          {isAdmin || isStaff || isB2bSalespersonUser ? <Route
            exact
            path="/B2B/orders"
            element={
              <Layout>
                <Orders orderType="B2B" />
              </Layout>
            }
          /> : <></>}
          {isAdmin || isStaff || isB2bSalespersonUser ? <Route
            exact
            path="/B2B/orders/add"
            element={
              <Layout>
                <ManageOrderForm platformType='B2B' />
              </Layout>
            }
          /> : <></>}
          {isAdmin || isStaff || isB2bSalespersonUser ? <Route
            exact
            path="/B2B/orders/:slug"
            element={
              <Layout>
                <ManageOrderForm platformType='B2B' />
              </Layout>
            }
          /> : <></>}
          {getUserRole() === "staff" || getUserRole() === "admin" ? <Route
            exact
            path="/third-party/orders"
            element={
              <Layout>
                <Orders orderType="THIRD_PARTY" />
              </Layout>
            }
          /> : <></>}
          {getUserRole() === "staff" || getUserRole() === "admin" ? <Route
            exact
            path="/third-party/orders/add"
            element={
              <Layout>
                <ManageOrderForm platformType="THIRD_PARTY" />
              </Layout>
            }
          /> : <></>}
          {getUserRole() === "staff" || getUserRole() === "admin" ? <Route
            exact
            path="/third-party/orders/:slug"
            element={
              <Layout>
                <ManageOrderForm platformType="THIRD_PARTY" />
              </Layout>
            }
          /> : <></>}
          {getUserRole() === "staff" || getUserRole() === "admin" ? <Route
            exact
            path="/shipments/add/"
            element={
              <Layout>
                <AddShipment />
              </Layout>
            }
          /> : <></>}
          {getUserRole() === "staff" || getUserRole() === "admin" ? <Route
            exact
            path="/shipments"
            element={
              <Layout>
                <Shipments />
              </Layout>
            }
          /> : <></>}
          {isAdmin || isStaff || isHrAdmin ? <Route
            exact
            path="/shipping-tracking"
            element={
              <Layout>
                <ShippingTrackingDashboard />
              </Layout>
            }
          /> : <></>}
          {getUserRole() === "admin" ? <Route
            exact
            path="/payments"
            element={
              <Layout>
                <Payments />
              </Layout>
            }
          /> : <></>}
          {getUserRole() === "admin" ? <Route
            exact
            path="/sales-stats"
            element={
              <Layout>
                <SalesDashboard />
              </Layout>
            }
          /> : <></>}
          {getUserRole() === "admin" ? <Route
            exact
            path="/product-sales"
            element={
              <Layout>
                <ProductSales />
              </Layout>
            }
          /> : <></>}
          {getUserRole() === "admin" ? <Route
            exact
            path="/product-sales/combined"
            element={
              <Layout>
                <ProductSalesCombined />
              </Layout>
            }
          /> : <></>}
          {getUserRole() === "admin" ? <Route
            exact
            path="/product-sales/:sku"
            element={
              <Layout>
                <ProductSalesDetail />
              </Layout>
            }
          /> : <></>}
          {getUserRole() === "admin" ? <Route
            exact
            path="/b2b-ledger"
            element={
              <Layout>
                <B2BLedgerPage />
              </Layout>
            }
          /> : <></>}
          {getUserRole() === "admin" ? <Route
            exact
            path="/b2c-ledger"
            element={
              <Layout>
                <B2CLedgerPage />
              </Layout>
            }
          /> : <></>}
          {getUserRole() === "admin" || getUserRole() === "staff" || isB2bSalespersonUser ? <Route
            exact
            path="/label-invoice"
            element={
              <Layout>
                <LabelInvoiceGenerator />
              </Layout>
            }
          /> : <></>}
          {getUserRole() === "admin" ? <Route
            exact
            path="/proforma-invoice"
            element={
              <Layout>
                <LabelInvoiceGenerator proformaOnly />
              </Layout>
            }
          /> : <></>}
          {getUserRole() === "admin" || getUserRole() === "staff" || isB2bSalespersonUser ? <Route
            exact
            path="/label-invoice/proforma/:proformaId"
            element={
              <Layout>
                <ProformaInvoiceEdit />
              </Layout>
            }
          /> : <></>}
          {getUserRole() === "admin" || getUserRole() === "staff" ? <Route
            exact
            path="/ecom-enquiries"
            element={
              <Layout>
                <EcomEnquiries />
              </Layout>
            }
          /> : <></>}
          {getUserRole() === "admin" ? <Route
            exact
            path="/bazzar/products"
            element={
              <Layout>
                <Products />
              </Layout>
            }
          /> : <></>}
          {getUserRole() === "admin" ? <Route
            exact
            path="/bazzar/products/add"
            element={
              <Layout>
                <ProductCreatePage />
              </Layout>
            }
          /> : <></>}
          {getUserRole() === "admin" ? <Route
            exact
            path="/bazzar/products/:slug"
            element={
              <Layout>
                <ProductDetailedPage />
              </Layout>
            }
          /> : <></>}
          {getUserRole() === "admin" ? <Route
            exact
            path="/bazzar/primary-products"
            element={
              <Layout>
                <PrimaryProducts />
              </Layout>
            }
          /> : <></>}
          {getUserRole() === "admin" ? <Route
            exact
            path="/details"
            element={
              <Layout>
                <StoreDetails />
              </Layout>
            }
          /> : <></>}
          {getUserRole() === "admin" ? <Route
            exact
            path="/account"
            element={
              <Layout>
                <AccountSettings />
              </Layout>
            }
          /> : <></>}
          {getUserRole() === "admin" ? <Route
            exact
            path="/bazzar/manufacturer"
            element={
              <Layout>
                <Manufacturers />
              </Layout>
            }
          /> : <></>}
          {getUserRole() === "admin" ? <Route
            exact
            path="/bazzar/manufacturer/:slug"
            element={
              <Layout>
                <ManufacturerForm />
              </Layout>
            }
          /> : <></>}
          {getUserRole() === "admin" || getUserRole() === "staff" ? <Route
            exact
            path="/bazzar/shop"
            element={
              <Layout>
                <Shop />
              </Layout>
            }
          /> : <></>}
          {getUserRole() === "admin" || getUserRole() === "staff" ? <Route
            exact
            path="/bazzar/shop/:slug"
            element={
              <Layout>
                <ShopForm />
              </Layout>
            }
          /> : <></>}
          {getUserRole() === "admin" ? <Route
            exact
            path="/bazzar/domains"
            element={
              <Layout>
                <Domains />
              </Layout>
            }
          /> : <></>}
          {getUserRole() === "admin" ? <Route
            exact
            path="/bazzar/domains/:slug"
            element={
              <Layout>
                <DomainForm />
              </Layout>
            }
          /> : <></>}
          {getUserRole() === "admin" ? <Route
            exact
            path="/bazzar/domains/categories/:slug"
            element={
              <Layout>
                <CategoryForm />
              </Layout>
            }
          /> : <></>}
          {getUserRole() === "admin" ? <Route
            exact
            path="/bazzar/domains/categories/sub-categories/:slug"
            element={
              <Layout>
                <SubCategoryForm />
              </Layout>
            }
          /> : <></>}
          {getUserRole() === "admin" ? <Route
            exact
            path="/bazzar/shop-products-dimension"
            element={
              <Layout>
                <ShopProductDimensions />
              </Layout>
            }
          /> : <></>}
          {getUserRole() === "admin" ? <Route
            exact
            path="/dashboard/bazaar/shop-products-dimension"
            element={
              <Layout>
                <ShopProductDimensions />
              </Layout>
            }
          /> : <></>}
          {getUserRole() === "admin" ? <Route
            exact
            path="/notification/notification-campaing"
            element={
              <Layout>
                <NotificationCampaign />
              </Layout>
            }
          /> : <></>}
          {getUserRole() === "admin" || getUserRole() === "staff" ? <Route
            exact
            path="/notification/notification-campaing/view/:slug"
            element={
              <Layout>
                <NotificationCampaignTemplateView />
              </Layout>
            }
          /> : <></>}
          {getUserRole() === "admin" || getUserRole() === "staff" ? <Route
            exact
            path="/notification/notification-campaing/:slug"
            element={
              <Layout>
                <NotificationCampaignForm />
              </Layout>
            }
          /> : <></>}
          {isAdmin || isHrAdmin ? <Route
            exact
            path="/marketing/community"
            element={
              <Layout>
                <Community />
              </Layout>
            }
          /> : <></>}
          {isAdmin || isHrAdmin ? <Route
            exact
            path="/marketing/community/:slug"
            element={
              <Layout>
                <CommunityForm />
              </Layout>
            }
          /> : <></>}
          {isAdmin || isStaff || isHrAdmin ? <Route
            exact
            path="/marketing/forum"
            element={
              <Layout>
                <Forum />
              </Layout>
            }
          /> : <></>}
          {isAdmin || isStaff || isHrAdmin ? <Route
            exact
            path="/marketing/banners"
            element={
              <Layout>
                <Banners />
              </Layout>
            }
          /> : <></>}
          {isAdmin || isStaff || isHrAdmin ? <Route
            exact
            path="/marketing/banners/:slug"
            element={
              <Layout>
                <BannersForm />
              </Layout>
            }
          /> : <></>}
          {isAdmin || isStaff || isHrAdmin ? <Route
            exact
            path="/marketing/mobile-pops"
            element={
              <Layout>
                <MobilePopups />
              </Layout>
            }
          /> : <></>}
          {isAdmin || isStaff || isHrAdmin ? <Route
            exact
            path="/marketing/mobile-pops/:slug"
            element={
              <Layout>
                <MobilePopupForm />
              </Layout>
            }
          /> : <></>}
          {getUserRole() === "admin" ? <Route
            exact
            path="/inventory/home"
            element={
              <Layout>
                <InventoryDashboard />
              </Layout>
            }
          /> : <></>}
          {getUserRole() === "admin" ? <Route
            exact
            path="/inventory/raw-items"
            element={
              <Layout>
                <RawItemsInventory />
              </Layout>
            }
          /> : <></>}
          {getUserRole() === "admin" ? <Route
            exact
            path="/inventory/raw-items/:slug"
            element={
              <Layout>
                <RawItemsInventoryForm />
              </Layout>
            }
          /> : <></>}
          {getUserRole() === "admin" ? <Route
            exact
            path="/inventory/products"
            element={
              <Layout>
                <ProductInventory />
              </Layout>
            }
          /> : <></>}
          {getUserRole() === "admin" ? <Route
            exact
            path="/inventory/products/:slug"
            element={
              <Layout>
                <ProductInventoryForm />
              </Layout>
            }
          /> : <></>}
          {getUserRole() === "admin" ? <Route
            exact
            path="/inventory/kit-assembly"
            element={
              <Layout>
                <KitAssembly />
              </Layout>
            }
          /> : <></>}
          {getUserRole() === "admin" ? <Route
            exact
            path="/inventory/product-stock"
            element={
              <Layout>
                <KitAssembly forProduct={true} />
              </Layout>
            }
          /> : <></>}
          {getUserRole() === "admin" ? <Route
            exact
            path="/inventory/kit-assembly/:slug"
            element={
              <Layout>
                <KitAssemblyForm />
              </Layout>
            }
          /> : <></>}
          {getUserRole() === "admin" ? <Route
            exact
            path="/inventory/product-stock/:slug"
            element={
              <Layout>
                <KitAssemblyForm forProduct={true} />
              </Layout>
            }
          /> : <></>}
          {getUserRole() === "admin" ? <Route
            exact
            path="/inventory/damage-replacements"
            element={
              <Layout>
                <DamageReplacements />
              </Layout>
            }
          /> : <></>}
          <Route
            exact
            path="/inventory/damage-replacements/report-damage"
            element={
              <Layout>
                <ReportDamageForm />
              </Layout>
            }
          />
          <Route
            exact
            path="/inventory/damage-replacements/request-replacement"
            element={
              <Layout>
                <RequestReplacementForm />
              </Layout>
            }
          />
          <Route
            exact
            path="/inventory/damage-replacements/status-report"
            element={
              <Layout>
                <StatusReportForm />
              </Layout>
            }
          />
          <Route
            exact
            path="*"
            element={
              <Layout>
                <PageNotFound />
              </Layout>
            }
          />
          {getUserRole() === "admin" ? <Route
                    exact
                    path="/flow-builder"
                    element={
                      <Layout>
                        <FlowBuilder />
                      </Layout>
                    }
          /> : <></>}
        </Routes>

        <ToastContainer stacked={true} />
      </div>
    </Router>
  );
}

export default App;
